import React from "react";
import {useMediaQuery} from "beautiful-react-hooks";
import { Link ,useParams} from "react-router-dom";

const colors = ["#0088FE", "#00C49F", "#FFBB28"];
const delay = 3500;



const items = [
    {
        "element": <img className="" src="https://static.sinatether.com/images/leverage_coins.svg" alt="کارمزد صفر برای معامله ارزدیجیتال | کمترین کارمزد خرید و فروش ارزدیجیتال"/>

    },
    {
      "element": <img className="" src="https://static.sinatether.com/images/ai_coins.svg" alt="ارز دیجیتال رایگان "/>

  },
    {
      "element": <img className="" src="https://static.sinatether.com/images/meme_coins.svg" alt="ارز دیجیتال رایگان "/>

  },
  {
    "element": <img className="" src="https://static.sinatether.com/images/game_coins.svg" alt="ارز دیجیتال رایگان "/>

},
   
]



const items_desk = [
    {
        "element": <img className={`img-slide2024 `} src="https://static.sinatether.com/images/leverage_coins_desk.svg" alt="لیست کامل ارزهای اهرم دار در سینا تتر"/>,
        "url":'/leverage-crypto-currencies-exchange'
    },
    {
      "element": <img className="img-slide2024" src="https://static.sinatether.com/images/ai_coins_desk.svg" alt="ارز دیجیتال هوش مصنوعی "/>,
      "url":'/all-ai-crypto-currencies-list'

  },
    {
      "element": <img className="img-slide2024" src="https://static.sinatether.com/images/meme_coins_desk.svg" alt="صرافی میم کوین در سینا تتر"/>,
      "url":'/meme-coins-exchange-and-list'


  },
  {
    "element": <img className="img-slide2024" src="https://static.sinatether.com/images/game_coins_desk.svg" alt="ارز دیجیتال بازی در سینا تتر "/>,
    "url":'/game-crypto-currencies-all-list'


},
   
]

export default function SliderTypes({type}) {
  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);
  const isSmall = useMediaQuery('(max-width: 768px)')









  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === items.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);





  function handleNext(){

    let next = index + 1 < items.length ? index + 1 : 0
    setIndex(next)
  }




  function handlePrev(){

    let prev = index - 1 < 0 ? 4 - 1 : index - 1;
      setIndex(prev)

  }

  return (

    <>


    {isSmall?
      <>
      <div className={`fjsflex53535 djnsudgtrfddd dliscard4242 mlr-22 mr-0 pading22btm kjdpadingjtop `}>


<div className="card3cssd2024">
            <div className="fjsflex53535 djshfsu55523ndnnn2024">








    

    <div
            className="slidetypeitem"
          
          >
                <a href={'/leverage-crypto-currencies-exchange'}>

            <div>
            <img className={`img-slide2024 ${type == 'lev' ? 'img-slide2024-active' : ''}`} src="https://static.sinatether.com/images/leverage_coins_desk.png" alt=""/>

            </div>

            </a>
              
    </div>





    

    <div
            className="slidetypeitem"
          
          >
                              <a href={'/all-ai-crypto-currencies-list'}>

            <div>
            <img className={`img-slide2024 ${type == 'ai' ? 'img-slide2024-active' : ''}`} src="https://static.sinatether.com/images/ai_coins_desk.png" alt=""/>


            </div>
            </a>

              
    </div>






    

    <div
            className="slidetypeitem"
          
          >

<a href={'/meme-coins-exchange-and-list'}>

            <div>
            <img className={`img-slide2024 ${type == 'meme' ? 'img-slide2024-active' : ''}`} src="https://static.sinatether.com/images/meme_coins_desk.png" alt=""/>


            </div>
            </a>

              
    </div>






    

    <div
            className="slidetypeitem"
          
          >

            <a href={'/game-crypto-currencies-all-list'}>

            <div>
            <img className={`img-slide2024 ${type == 'game' ? 'img-slide2024-active' : ''}`} src="https://static.sinatether.com/images/game_coins_desk.png" alt=""/>


            </div>

            </a>


              
    </div>






    </div>











</div>



</div>


  
      
      </>

      :


      <>
            <div className={`fjsflex53535 djnsudgtrfddd dliscard4242  pading22btm kjdpadingjtop ja-center`}>


      <div className="card3cssd2024">
                  <div className="fjsflex53535 djshfsu55523ndnnn2024 ">
      
      
      
      
      
      
      
      
          
      
          <div
                  className="slidetypeitem-desk"
                >
                              <a href={'/leverage-crypto-currencies-exchange'}>

                                <div>

                                <img className={`img-slide2024 ${type == 'lev' ? 'img-slide2024-active' : ''} `} src="https://static.sinatether.com/images/leverage_coins_desk.png" alt="کارمزد صفر برای معامله ارزدیجیتال | کمترین کارمزد خرید و فروش ارزدیجیتال"/>



                                </div>


                    </a>
          </div>




          
          <div
                  className="slidetypeitem-desk"
                >
                              <a href={'/all-ai-crypto-currencies-list'}>

                                <div>

                                <img className={`img-slide2024 ${type == 'ai' ? 'img-slide2024-active' : ''} `} src="https://static.sinatether.com/images/ai_coins_desk.png" alt="کارمزد صفر برای معامله ارزدیجیتال | کمترین کارمزد خرید و فروش ارزدیجیتال"/>



                                </div>


                    </a>
          </div>





          
          <div
                  className="slidetypeitem-desk"
                >
                              <a href={'/meme-coins-exchange-and-list'}>

                                <div>

                                <img className={`img-slide2024 ${type == 'meme' ? 'img-slide2024-active' : ''} `} src="https://static.sinatether.com/images/meme_coins_desk.png" alt="کارمزد صفر برای معامله ارزدیجیتال | کمترین کارمزد خرید و فروش ارزدیجیتال"/>



                                </div>


                    </a>
          </div>





          
          <div
                  className="slidetypeitem-desk"
                >
                              <a href={'/game-crypto-currencies-all-list'}>

                                <div>

                                <img className={`img-slide2024 ${type == 'game' ? 'img-slide2024-active' : ''} `} src="https://static.sinatether.com/images/game_coins_desk.png" alt="کارمزد صفر برای معامله ارزدیجیتال | کمترین کارمزد خرید و فروش ارزدیجیتال"/>



                                </div>


                    </a>
          </div>
      



        
          </div>
      
      
      
      
      
      
      
      
      
      
      
      </div>



      </div>
      
      
        
            
            </>


  

    }

</>

  );
}

